import { render, staticRenderFns } from "./TheadRibbons.vue?vue&type=template&id=2e2440f6"
import script from "./TheadRibbons.vue?vue&type=script&lang=js"
export * from "./TheadRibbons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports